import React from 'react';
import type { InvoicePackingAlert } from '../../lib/packingAlertsApi';

/**
 * "Check the packing" on the invoice line itself (D29, MC-5). The server works
 * the alerts out on read (`packingAlert.service.packingAlertsForInvoice`); this
 * only prints them. Warn only: nothing here blocks Confirm & sync (Q11).
 */
export default function PackingAlertNote({
  alerts,
  lineNo,
  canEdit,
  onUsePackCount,
}: {
  alerts: InvoicePackingAlert[];
  lineNo: number;
  /** Master Catalogue edit rights, which decide who resolves it. */
  canEdit: boolean;
  /**
   * Stage Units per Case = the count the item name states, as if typed. Omitted
   * on a read-only invoice, and then no button is offered.
   */
  onUsePackCount?: (count: number) => void;
}) {
  return (
    <div
      role="note"
      aria-label={`Check the packing for line ${lineNo}`}
      className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900"
    >
      <div className="font-semibold">Check the packing in the Master Catalogue</div>
      <ul className="mt-1 list-disc space-y-0.5 pl-4">
        {alerts.map((alert, i) => (
          <li key={`${alert.kind}-${i}`}>
            {alert.message}
            {onUsePackCount && typeof alert.suggestedPackCount === 'number' && alert.suggestedPackCount > 1 ? (
              <button
                type="button"
                onClick={() => onUsePackCount(alert.suggestedPackCount as number)}
                className="ml-2 rounded border border-amber-300 bg-white px-2 py-0.5 text-xs font-semibold text-amber-900 hover:bg-amber-100"
              >
                Use {alert.suggestedPackCount}
              </button>
            ) : null}
          </li>
        ))}
      </ul>
      <div className="mt-1 text-amber-800">
        {canEdit
          ? 'Once the packaging is right, mark it checked under Master Catalogue, Packing alerts. This never blocks Confirm & sync.'
          : 'Someone with Master Catalogue edit rights will check it. This never blocks Confirm & sync.'}
      </div>
    </div>
  );
}
